import React from 'react';
import MainLayout from '../layouts/MainLayout';
import SEOHead from '../components/SEOHead';

// Define social media links with their respective styles
const socialLinks = [
  {
    name: 'Facebook',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"/>
      </svg>
    ),
    bgColor: 'bg-blue-500',
    hoverColor: 'hover:bg-blue-600',
    url: 'https://www.facebook.com/profile.php?id=61575880593714'
  },
  {
    name: 'Instagram',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5a4.25 4.25 0 004.25 4.25h8.5a4.25 4.25 0 004.25-4.25v-8.5a4.25 4.25 0 00-4.25-4.25h-8.5z"/>
        <path d="M12 7a5 5 0 100 10 5 5 0 000-10zm0 1.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"/>
        <circle cx="17.5" cy="6.5" r="1.25"/>
      </svg>
    ),
    bgColor: 'bg-pink-500',
    hoverColor: 'hover:bg-pink-600',
    url: 'https://www.instagram.com/refreshbulgaria'
  },
  {
    name: 'YouTube',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    bgColor: 'bg-red-500',
    hoverColor: 'hover:bg-red-600',
    url: 'https://www.youtube.com/@refreshbulgaria'
  },
  {
    name: 'TikTok',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
    bgColor: 'bg-black',
    hoverColor: 'hover:bg-gray-800',
    url: 'https://www.tiktok.com/@refreshbulgaria'
  }
];

const ContactsPage = () => {
  return (
    <MainLayout>
      <SEOHead 
        title="Контакти - Refresh Bulgaria"
        description="Свържете се с Refresh Bulgaria за въпроси, партньорства или участие в наши екологични инициативи. Телефон, имейл и социални мрежи."
        keywords="контакти refresh bulgaria, свързване екология, партньорство околна среда, доброволчество контакти"
        url="https://refreshbulgaria.com/contacts"
      />
      <div className="max-w-screen-xl mx-auto px-4">
        <main className="mt-4">
          {/* Hero Section */}
          <section className="mb-8">
            <div className="bg-gradient-to-r from-green-700 to-green-600 rounded-lg p-8 md:p-12 text-white">
              <h1 className="text-3xl md:text-4xl font-bold mb-4">Свържете се с нас</h1>
              <p className="text-xl md:text-2xl opacity-90">
                Имате въпроси или искате да участвате в нашите инициативи?
              </p>
            </div>
          </section>

          {/* Contact Information Cards */}
          <section className="mb-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {/* Email Card */}
              <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center mb-4">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-green-800">Електронна поща</h3>
                    <p className="text-gray-600">Свържете се с нас по имейл</p>
                  </div>
                </div>
                <a href="mailto:refrshbulgaria@gmail.com" className="text-green-700 font-medium hover:text-green-600 transition-colors">
                  refrshbulgaria@gmail.com
                </a>
              </div>

              {/* Phone Card */}
              <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center mb-4">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-green-800">Телефон</h3>
                    <p className="text-gray-600">Обадете ни се директно</p>
                  </div>
                </div>
                <a href="tel:+359899802702" className="text-green-700 font-medium hover:text-green-600 transition-colors">
                  +359 899 802 702
                </a>
              </div>
            </div>
          </section>

          {/* Social Media Section */}
          <section className="mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-2xl font-bold text-green-800 mb-4 text-center">Последвайте ни в социалните медии</h2>
              <p className="text-gray-600 text-center mb-6">Оставайте в течение с най-новите ни събития и инициативи</p>
              <div className="flex flex-wrap justify-center gap-4 md:gap-6">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.url} 
                    className={`flex flex-col items-center p-4 rounded-lg w-24 ${social.bgColor} ${social.hoverColor} text-white transition-colors duration-300 hover:scale-105 transform`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="mb-2">
                      {social.icon}
                    </div>
                    <span className="text-sm font-medium">{social.name}</span>
                  </a>
                ))}
              </div>
            </div>
          </section>

        </main>
      </div>
    </MainLayout>
  );
};

export default ContactsPage; 